<form [formGroup]="fg" (submit)="onUpload()">
  <aux-modal primaryButtonType="submit" [loading]="loading()">
    <div class="w-screen max-w-2xl font-inter">
      <div class="grid grid-cols-2 gap-5">
        <div class="flex flex-col justify-start">
          <div [auxTooltip]="isVendorDisabled ? 'Vendor cannot be updated.' : ''">
            <div class="mb-2 text-xs">Vendor Contract</div>
            <ng-select
              placeholder="Select"
              formControlName="organization_id"
              [class.opacity-50]="isVendorDisabled"
              class="select select__big"
              label="Vendor Contract"
              auxFormError
              [searchable]="true"
              [clearable]="false"
              bindLabel="name"
              bindValue="id"
              [items]="vendorOptions()"
            >
              <ng-template let-item="item" ng-option-tmp>
                <div
                  [auxTooltip]="!item.current_budget_versions?.length ? tooltip : ''"
                  [auxTooltipPositions]="optionTooltipPositions"
                >
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div>
            <aux-input
              class="mt-2 text-xs"
              formControlName="change_order_no"
              label="Change Order #"
              [validators]="changeOrderNoValidators"
            />
          </div>

          <div>
            <aux-input
              class="mt-2 text-xs"
              formControlName="date_received"
              label="Date Received"
              placeholder="YYYY-MM-DD"
              validators="required"
              [type]="'date'"
            />
          </div>

          <div>
            <aux-input
              class="mt-2 text-xs"
              formControlName="effective_date"
              label="Effective Date"
              placeholder="YYYY-MM-DD"
              validators="required"
              [type]="'date'"
            />
          </div>

          <div>
            <aux-input
              label="Change Order Notes"
              formControlName="notes"
              class="col-span-6 mt-2 text-xs"
              [textArea]="true"
              [rows]="3"
            />
          </div>
        </div>
        <div class="flex flex-col">
          <div class="mb-2 ml-2 text-xs">Upload Change Order</div>
          <aux-file-manager #fileManager class="mb-2 ml-2 h-56" [eager]="false" [path]="''" />
          <div class="ml-2 text-xs">Uploaded Files</div>
          @if (fileManager.fileQuery.selectAll() | async; as files) {
            @if (files.length) {
              @for (file of files; track file; let last = $last) {
                <ng-container class="border-b">
                  <div
                    class="flex items-center justify-between py-2"
                    [ngClass]="{ 'border-b': !last }"
                  >
                    <div class="items-start break-all pl-2 text-xs">
                      {{ file.fileName }}
                    </div>

                    <button
                      class="btn h-6 w-6 rounded-full border-0 p-0 shadow-none"
                      type="button"
                      (click)="removeFile(file)"
                    >
                      <aux-icon name="Trash" class="text-aux-error" />
                    </button>
                  </div>
                </ng-container>
              }
            }
          }
        </div>
      </div>

      @if (errorMessage()) {
        <div class="mt-4 rounded-md bg-aux-error p-4 text-white">
          <div>{{ errorMessage() }}</div>
        </div>
      }
    </div>
  </aux-modal>
</form>
